module.exports = __webpack_public_path__ + "communication-white.svg?8ac97dc739219dd5f65f32a6c0dda947";